<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeMateriel.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeMateriel.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.code')">
          <qd-taginput v-model="newCritereRecherche.codes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div
        v-if="moduleLogistiqueImpressionActive"
        class="column is-12 pdb-0">
        <libelle-tag-input
          v-model="newCritereRecherche.formatAfficheIds"
          :label="$t('listeMateriel.filtre.formatAffiche')"
          :items="formatAffiche"
          field="libelle">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.format')">
          <qd-taginput v-if="formatTags"
                      v-model="formatSelected"
                      :data="formatTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredFormatTags"
                      @input="getFormatTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.typeMateriel')">
          <qd-taginput v-if="materielTypeTags"
                      v-model="materielTypeSelected"
                      :data="materielTypeTags"
                      type="is-primary"
                      icon="magnify"
                      autocomplete
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredMaterielTypeTags"
                      @input="getMaterielTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.typeDispositif')">
          <qd-taginput v-if="dispositifTypeTags"
                      v-model="dispositifTypeSelected"
                      :data="dispositifTypeTags"
                      type="is-primary"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      field="libelle"
                      @typing="getFilteredDispositifTypeTags"
                      @input="getDispositifTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.typeSupport')">
          <qd-taginput v-if="supportTypeTags"
                      v-model="supportTypeSelected"
                      :data="supportTypeTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredSupportTypeTags"
                      @input="getSupportTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeMateriel.filtre.etat')"
                      :items="constantes.ETAT_DISPOSITIF_PUBLICITAIRE"
                      v-model="etatSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.dateMontage')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesMontage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContrat.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesMontage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.dateDemontage')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesDemontage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeMateriel.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesDemontage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.adresse')">
          <b-input v-model="newCritereRecherche.adresse">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.ville')">
          <ville-tag-input-auto-complete
              :critere-recherche="newCritereRecherche"
              table-name="Emplacement"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.codePostal')">
          <qd-taginput type='is-primary' v-model="newCritereRecherche.codesPostaux"></qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.agglomerations')">
          <qd-taginput v-model="newCritereRecherche.agglomerations" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.departements')">
          <qd-taginput v-model="newCritereRecherche.departements" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleEmplacementClientActive">
        <query-client-tag-input
          v-model="clientsSelected"
          :societeActiveId="societeActiveId"
          :label="$t('listeMateriel.filtre.client')">
        </query-client-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeMateriel.filtre.tags')"
          v-model="newCritereRecherche.tagIds"
          :query="(s) => func.getAllTags({ query: {
            auto: s,
            actif: true,
            moduleTag: constantes.DISPOSITIF,
          }})">
          <template #default="{ option }">
            {{ option.libelle }}
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeCollectivite.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="moduleSecteurActive">
        <secteur-tag-input v-model="secteursSelected"
          :label="$t('listeDispositif.filtre.secteur')"
          :critere="(el) => el.type === constantes.PATRIMOINE"
          :disabled="secteurCurrentUser.length > 0">
        </secteur-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.actif')">
          <b-select v-model="newCritereRecherche.actif">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.eclaire')">
          <b-select v-model="newCritereRecherche.eclaire">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.associeABail')">
          <b-select v-model="newCritereRecherche.estAssocieABail">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.avecCoordonnees')">
          <b-select v-model="newCritereRecherche.avecCoordonnees">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeMateriel.filtre.idPlayer')">
          <qd-taginput type='is-primary' v-model="newCritereRecherche.idPlayers"></qd-taginput>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
              @click="appliquerCritere()">
        {{ $t('listeMateriel.filtre.actions.appliquer') }}
      </button>

      <button @click="viderCritere()"
              class="button border-none mgt-10px has-text-icon-more pd-10px">
        {{ $t('listeMateriel.filtre.actions.reinitialiser') }}
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { getAll as getAllTags } from '@/api/tag/index';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRechercheMateriel from '@/services/gabed/materiel/genererCritereRechercheMateriel';
import { DISPOSITIF } from '@/configuration/parametrage/tagConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import secteurTagInput from '@/components/commun/secteur/secteurTagInput';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import queryClientTagInput from '@/components/general/tagInput/queryClientTagInput';
import queryTagInput from '@/components/general/tagInput/queryTagInput';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    libelleTagInput,
    agenceTagInput,
    VilleTagInputAutoComplete,
    queryClientTagInput,
    secteurTagInput,
    queryTagInput,
  },
  data() {
    return {
      newCritereRecherche: null,
      formatTags: null,
      formatSelected: [],
      formatBase: [],
      materielTypeTags: null,
      materielTypeSelected: [],
      materielTypeBase: [],
      dispositifTypeTags: null,
      dispositifTypeSelected: [],
      dispositifTypeBase: [],
      supportTypeTags: null,
      supportTypeSelected: [],
      supportTypeBase: [],
      datesMontage: {
        dateDebut: null,
        dateFin: null,
      },
      datesDemontage: {
        dateDebut: null,
        dateFin: null,
      },
      constantes: {
        ETAT_DISPOSITIF_PUBLICITAIRE,
        PATRIMOINE,
        DISPOSITIF,
      },
      func: {
        getAllTags,
      },
      etatSelected: [],
      clientsSelected: [],
      secteursSelected: [],
      secteurCurrentUser: [],
    };
  },
  props: {
    critereRecherche: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    appliquerCritere() {
      this.newCritereRecherche.datesMontage = this.datesMontage;
      if (!this.newCritereRecherche.datesMontage.dateDebut
        && !this.newCritereRecherche.datesMontage.dateFin) {
        this.newCritereRecherche.datesMontage = null;
      }
      this.newCritereRecherche.datesDemontage = this.datesDemontage;
      if (!this.newCritereRecherche.datesDemontage.dateDebut
        && !this.newCritereRecherche.datesDemontage.dateFin) {
        this.newCritereRecherche.datesDemontage = null;
      }
      this.newCritereRecherche.supports = this.supportTypeSelected.map(el => { return el.id; });
      this.newCritereRecherche.typesDispositifs = this.dispositifTypeSelected.map(el => {
        return el.id;
      });
      this.newCritereRecherche.typesMateriels = this.materielTypeSelected.map(el => {
        return el.id;
      });
      this.newCritereRecherche.formats = this.formatSelected.map(el => { return el.id; });
      this.newCritereRecherche.etats = this.etatSelected.map(el => { return el.value; });
      this.newCritereRecherche.clients = this.clientsSelected;
      this.newCritereRecherche.secteurs = this.secteursSelected.map(el => {
        return el.id;
      });
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.datesDemontage = {
        dateDebut: null,
        dateFin: null,
      };
      this.datesMontage = {
        dateDebut: null,
        dateFin: null,
      };
      this.formatSelected = [];
      this.getFormatTag();
      this.materielTypeSelected = [];
      this.getMaterielTypeTag();
      this.supportTypeSelected = [];
      this.getSupportTypeTag();
      this.dispositifTypeSelected = [];
      this.getDispositifTypeTag();
      this.etatSelected = [];
      this.clientsSelected = [];
      this.secteursSelected = this.secteurCurrentUser ?? [];
      this.newCritereRecherche = genererCritereRechercheMateriel();
      this.etatSelected = this.constantes.ETAT_DISPOSITIF_PUBLICITAIRE.filter((c) => {
        return this.newCritereRecherche.etats.includes(c.value);
      });
    },
    getFilteredFormatTags(text) {
      this.getFormatTag();
      this.formatTags = this.formatTags.filter((format) => {
        return format.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFormatTag() {
      this.formatTags = this.listeFormatBase.filter((format) => {
        return !this.formatSelected.map(a => a.id).includes(format.id);
      });
    },
    getFilteredMaterielTypeTags(text) {
      this.getMaterielTypeTag();
      this.materielTypeTags = this.materielTypeTags.filter((materiel) => {
        return materiel.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getMaterielTypeTag() {
      this.materielTypeTags = this.materielTypeBase.filter((materiel) => {
        return !this.materielTypeSelected.map(a => a.id).includes(materiel.id);
      });
    },
    getFilteredDispositifTypeTags(text) {
      this.getDispositifTypeTag();
      this.dispositifTypeTags = this.dispositifTypeTags.filter((dispo) => {
        return dispo.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getDispositifTypeTag() {
      this.dispositifTypeTags = this.dispositifTypeBase
        .filter((dispo) => {
          return !this.dispositifTypeSelected.map(a => a.id).includes(dispo.id);
        })
        .filter(dispo => dispo.actif);
    },
    getFilteredSupportTypeTags(text) {
      this.getSupportTypeTag();
      this.supportTypeTags = this.supportTypeTags.filter((support) => {
        return support.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getSupportTypeTag() {
      this.supportTypeTags = this.supportTypeBase.filter((support) => {
        return !this.supportTypeSelected.map(a => a.id).includes(support.id);
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.newCritereRecherche = cloneDeep(this.critereRecherche);
        await this.loadParametres([
          PARAMETRES_KEYS.materielFormat,
          PARAMETRES_KEYS.materielType,
          PARAMETRES_KEYS.dispositifType,
          PARAMETRES_KEYS.dispositifSupport,
          PARAMETRES_KEYS.formatAffiche,
        ]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
          PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
          PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key,
        ]);
        this.listeFormatBase = this.format;
        if (this.newCritereRecherche.formats) {
          this.formatSelected = this.listeFormatBase.filter((c) => {
            return this.newCritereRecherche.formats.includes(c.id);
          });
        }
        this.getFormatTag();

        this.materielTypeBase = this.materielType;
        if (this.newCritereRecherche.typesMateriels) {
          this.materielTypeSelected = this.materielTypeBase.filter((c) => {
            return this.newCritereRecherche.typesMateriels.includes(c.id);
          });
        }
        this.getMaterielTypeTag();

        this.dispositifTypeBase = this.dispositifType;
        if (this.newCritereRecherche.typesDispositifs) {
          this.dispositifTypeSelected = this.dispositifTypeBase.filter((c) => {
            return this.newCritereRecherche.typesDispositifs.includes(c.id);
          });
        }
        this.getDispositifTypeTag();

        this.supportTypeBase = this.supportType;
        if (this.newCritereRecherche.supports) {
          this.supportTypeSelected = this.supportTypeBase.filter((c) => {
            return this.newCritereRecherche.supports.includes(c.id);
          });
        }
        this.getSupportTypeTag();

        if (this.newCritereRecherche.etats) {
          this.etatSelected = this.constantes.ETAT_DISPOSITIF_PUBLICITAIRE.filter((c) => {
            return this.newCritereRecherche.etats.includes(c.value);
          });
        }

        if (this.newCritereRecherche.datesMontage) {
          this.datesMontage = cloneDeep(this.newCritereRecherche.datesMontage);
        }
        if (this.newCritereRecherche.datesDemontage) {
          this.datesDemontage = cloneDeep(this.newCritereRecherche.datesDemontage);
        }
        this.clientsSelected = this.newCritereRecherche.clients;
        this.secteurCurrentUser = await getSecteursIdByUser(PATRIMOINE, true);
        if (this.secteurCurrentUser) {
          this.secteursSelected = this.secteurCurrentUser;
        }
        if (this.newCritereRecherche.secteurs.length > 0) {
          this.secteursSelected = this.secteurs.filter((s) => {
            return this.newCritereRecherche.secteurs.includes(s.id) && s.actif === true;
          });
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    format() {
      return this.parametre(PARAMETRES_KEYS.materielFormat)
        .filter(format => format.actif);
    },
    materielType() {
      return this.parametre(PARAMETRES_KEYS.materielType).filter(m => m.actif);
    },
    dispositifType() {
      return this.parametre(PARAMETRES_KEYS.dispositifType);
    },
    supportType() {
      return this.parametre(PARAMETRES_KEYS.dispositifSupport).filter(s => s.actif);
    },
    formatAffiche() {
      return this.parametre(PARAMETRES_KEYS.formatAffiche).map(f => ({
        ...f,
        libelle: `${f.code} - ${f.libelle}`,
      }));
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    moduleLogistiqueImpressionActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleLogistiqueImpression.key);
    },
    secteurs() {
      return this.parametre(PARAMETRES_KEYS.secteur);
    },
  },
  async mounted() {
    await this.initializeFiltre();
  },
};
</script>

<style scoped>

</style>
